import {Component} from '@angular/core';

@Component({
  selector: 'rn-registration-age-validation',
  templateUrl: './registration-age-validation.component.html',
  styleUrl: './registration-age-validation.component.scss',
  standalone: false
})
export class RegistrationAgeValidationComponent {


}
